import { createSignal, createEffect, onCleanup, For, Show, createMemo, onMount } from "solid-js";
import { customElement } from "solid-element";
import { socialIcons } from "./assets/assets";
import {setTranslations, translations} from "../../services/context";
import { getTranslations } from "../../services/translation";


customElement(
    "builderall-social-media-share",
    { show: false, link: '', text: '', shorttext: '' },
    (props) => {
        function destroyOnClickOutside(e) {
            if (e.target.classList.contains("social-media-share-modal")) {
                document.querySelector("builderall-social-media-share").setAttribute('show', 'false')
            }
        }

        const textEncoded = encodeURIComponent(props.text);
        const shortTextEncoded = encodeURIComponent(props.shorttext);
        const linkEncoded = encodeURIComponent(props.link)

        const links = {
            X: `https://twitter.com/intent/tweet?text=${shortTextEncoded}&url=${linkEncoded}`,
            WHATSAPP: `https://api.whatsapp.com/send?text=${textEncoded}`,
            LINKEDIN: `https://www.linkedin.com/sharing/share-offsite/?url=${linkEncoded}`,
            FACEBOOK: `https://www.facebook.com/sharer/sharer.php?u=${linkEncoded}`,
            EMAIL: `mailto:?subject=&body=${encodeURIComponent(textEncoded)}`
        }

        const copyText = (text, event) => {
            navigator.clipboard.writeText(text);
            const iconElement = event.currentTarget.querySelector('builderall-icon');
            iconElement.setAttribute('code', 'ad00')
            setTimeout(() => iconElement.setAttribute('code', 'f5ff'), 2e3);
        };

        return (
            <>
                <Show when={props.show}>

                <style>{require("bundle-text:./styles/index.scss")}</style>

                <div class="social-media-share-modal modal-backdrop" onClick={destroyOnClickOutside}>
                    <div class="modal">
                        <div class="modal-header">
                            <h2 class="ba-title">Share Your Creation</h2>
                            <p class="ba-subtitle">Share your new website on social media</p>
                            <button class="ba-btn btn-close" onClick={destroyOnClickOutside}>
                                <builderall-icon code="64f7"></builderall-icon>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="social-col">
                                <div class="social-card">
                                    <header class="social-card-header">
                                        <span class="social-card-header-avatar"></span>
                                        <div class="social-card-header-placeholder-container">
                                            <span class="social-card-header-placeholder"></span>
                                            <span class="social-card-header-placeholder"></span>
                                        </div>
                                    </header>
                                    <div class="social-card-body">
                                        <p>
                                            {props.shorttext}
                                            <br></br><br></br>
                                            🌐 {props.link}
                                        </p>

                                        <button class="copy-button" onClick={[copyText, props.shorttext]}>
                                            <builderall-icon code='f5ff' style="--builderall-icon-size:18px;--builderall-icon-color:#8F9FB6"></builderall-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="social-card small-padding">
                                    <div class="social-card-body">
                                        <p> Share on socials </p>
                                        <ul class="social-icons-grid">
                                            <li>
                                                <a href={links.X} target="_blank" rel="noopener noreferrer">
                                                    <span innerHTML={socialIcons.X}></span> 
                                                    <p>X</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="social-col">
                                <div class="social-card">
                                    <header class="social-card-header">
                                        <span class="social-card-header-avatar"></span>
                                        <div>
                                            <span class="social-card-header-placeholder"></span>
                                            <span class="social-card-header-placeholder"></span>
                                        </div>
                                    </header>
                                    <div class="social-card-body">
                                        <p>
                                            {props.text}
                                        </p>
                                        <button class="copy-button" onClick={[copyText, props.text]}>
                                            <builderall-icon code="f5ff" style="--builderall-icon-size:18px;--builderall-icon-color:#8F9FB6"></builderall-icon>
                                        </button>
                                    </div>
                                </div>
                                
                                <div class="social-card small-padding">
                                    <div class="social-card-body">
                                        <p> Share on socials </p>
                                        <ul class="social-icons-grid">
                                            <li>
                                                <a href={links.WHATSAPP} target="_blank" rel="noopener noreferrer">
                                                    <span innerHTML={socialIcons.WHATSAPP}></span> 
                                                    <p>Whatsapp</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href={links.LINKEDIN} target="_blank" rel="noopener noreferrer">
                                                    <span innerHTML={socialIcons.LINKEDIN}></span> 
                                                    <p>Linkedin</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href={links.FACEBOOK} target="_blank" rel="noopener noreferrer">
                                                    <span innerHTML={socialIcons.FACEBOOK}></span> 
                                                    <p>Facebook</p>
                                                </a>
                                            </li>
                                            <li>
                                                <a href={links.EMAIL} target="_blank" rel="noopener noreferrer">
                                                    <span innerHTML={socialIcons.EMAIL}></span> 
                                                    <p>Email</p>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </Show>
            </>
        );
    }
);
